<div class="row" *ngIf="addresses">
  <div class="col-md-6 col-lg-4" *ngFor="let address of addresses">
    <pv-address
      [selected]="address == selected"
      [selectable]="selectable"
      [editable]="editable"
      [address]="address"
      (onSelect)="select(address)"
      (onEdit)="edit(address)"
      (onDelete)="delete(address)"
    ></pv-address>
  </div>

  <!-- NEW ADDRESS THING -->
  <div class="col-sm-6 col-lg-4 outside-address" *ngIf="selectable" (click)="newAddress()">
    <div class="address-wrapper light-primary-border-color new-address light-primary-background hover-lightest-accent-background">
      <div class="add-address-text">Add a new address</div>
    </div>
  </div>
</div>